import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export default function CampaignDetailsInfo({ detailItems, getStatusColor }) {
    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {detailItems.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 0.5, sm: 2 },
                            alignItems: { xs: 'flex-start', sm: 'center' },
                            py: 1,
                            borderBottom: index < detailItems.length - 1 ? '1px solid' : 'none',
                            borderColor: 'grey.100'
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            sx={{ minWidth: { sm: '150px' }, fontWeight: 600, fontSize: '0.875rem' }}
                        >
                            {item.label}
                        </Typography>
                        <Box sx={{ flex: 1 }}>
                            {item.type === 'status' ? (
                                <Chip
                                    label={item.value}
                                    color={getStatusColor(item.value)}
                                    size="small"
                                    sx={{ fontWeight: 500, borderRadius: 2 }}
                                />
                            ) : item.type === 'description' ? (
                                <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
                                    {item.value}
                                </Typography>
                            ) : item.type === 'number' ? (
                                <Typography variant="body1" sx={{ color: '#3483fa', fontWeight: 600, fontSize: '1.1rem' }}>
                                    {item.value.toLocaleString('pt-BR')}
                                </Typography>
                            ) : (
                                <Typography variant="body1" sx={{ color: 'grey.700', fontWeight: item.label === 'Nome' ? 500 : 400 }}>
                                    {item.value}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
